import { useDevice } from 'lib/hooks/useDevice';
import { Promotions } from 'lib/types/promotion';
import { BookingModal } from '../Modal/BookingModal';
import { PaymentDetailsLoadingFallback } from './PaymentDetails.fallback';
import { PaymentDetailsComponent } from './PaymentDetailsComponent';

type Props = {
  isOpen: boolean;
  close: () => void;
  promotions: Promotions | undefined;
  addPromotion: (code: string) => void;
  removePromotion: (code: string) => void;
  addingPromotionLoading: boolean;
  removingPromotionLoading: boolean;
  eitherAddOrRemoveAreLoading: boolean;
  refetch: () => any;
  hasAltMobileDesign: boolean;
  isLoading: boolean;
  errorMessagePromo: string;
  setErrorMessagePromo: any;
};

const PaymentDetailsMobile = ({
  isOpen,
  close,
  promotions,
  addPromotion,
  removePromotion,
  addingPromotionLoading,
  removingPromotionLoading,
  eitherAddOrRemoveAreLoading,
  refetch,
  hasAltMobileDesign,
  isLoading,
  errorMessagePromo,
  setErrorMessagePromo,
}: Props) => {
  const { isMobile } = useDevice();

  return (
    <BookingModal
      isOpen={isOpen && isMobile}
      close={close}
      title="Payment Details"
    >
      {!isLoading && promotions ? (
        <PaymentDetailsComponent
          promotions={promotions}
          addPromotion={addPromotion}
          removePromotion={removePromotion}
          addingPromotionLoading={addingPromotionLoading}
          removingPromotionLoading={removingPromotionLoading}
          eitherAddOrRemoveAreLoading={eitherAddOrRemoveAreLoading}
          refetch={refetch}
          hasAltMobileDesign={hasAltMobileDesign}
          errorMessagePromo={errorMessagePromo}
          setErrorMessagePromo={setErrorMessagePromo}
        />
      ) : (
        <PaymentDetailsLoadingFallback />
      )}
    </BookingModal>
  );
};

export { PaymentDetailsMobile };
